import UserSettingApi from '@/api/UserSettingApi';

class UserSettingsService {

	async selectSettingAsync (...args: Parameters<typeof UserSettingApi.selectSetting>) {
		const res = await UserSettingApi.selectSetting(...args);
		return res?.data;
	}

	async updateSettingAsync (...args: Parameters<typeof UserSettingApi.updateSetting>) {
		const { data } = await UserSettingApi.updateSetting(...args);
		return data;
	}

}

export default function useUserSettingsService () {
	return new UserSettingsService();
}
